export const removeDataLoadAtFirst = () => {
  if (localStorage.getItem('dataAtFirstLoad')){
    localStorage.removeItem('dataAtFirstLoad');
  }
};
